class MeshSelectionStore {
    constructor() {
        this.clickedTooth = null;
        this.modifications = null;
    }

    getClickedTooth() {
        return this.clickedTooth;
    }

    setClickedTooth(tooth) {
        this.clickedTooth = tooth;
    }

    clearClickedTooth() {
        this.clickedTooth = null;
    }

    getModifications() {
        return this.modifications;
    }

    setModifications(nextModifications) {
        this.modifications = nextModifications;
    }

    setModificationNote(index, note) {
        if (this.modifications && this.modifications[index]) {
            this.modifications[index].note = note;
        }
    }

    dispose() {
        this.clickedTooth = null;
        this.modifications = null;
    }
}

export const meshSelectionStore = new MeshSelectionStore();
export { MeshSelectionStore };
